module.exports = __webpack_public_path__ + "img/Forum.c3bb5181.svg";